import { useMemo } from 'react'
import { runQuery } from './engine'
import { frameForConfig } from './frames'
import { FrameRow, QueryResult, ViewConfig } from './view-config'

/**
 * Derives the query result for a view config, plus the filtered-but-not-
 * grouped rows the summary cards need (same filters, forced to list kind
 * with limit 0 = "all" so totals cover the whole filter set, not the default
 * ten-row cap). Both run against the config's frame (defaults to the deal frame).
 */
export function useReportResult(config: ViewConfig | undefined): {
  result: QueryResult | undefined
  filteredRows: FrameRow[]
} {
  const result = useMemo(
    () => (config ? runQuery(config, frameForConfig(config)) : undefined),
    [config]
  )
  const filteredRows = useMemo(() => {
    if (!config) return []
    const r = runQuery(
      { ...config, kind: 'list', sort: undefined, limit: 0 },
      frameForConfig(config)
    )
    return r.kind === 'list' ? r.rows : []
  }, [config])
  return { result, filteredRows }
}
